var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebtmanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7241 27.1767H6.52959C5.02263 27.1767 3.79663 25.793 3.79663 24.0814V3.91897C3.79663 2.21225 5.01837 0.82373 6.52959 0.82373H36.7241C38.231 0.82373 39.457 2.20743 39.457 3.91897V24.0814C39.4528 25.7882 38.231 27.1767 36.7241 27.1767Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5H3V10H40V5Z",
    fill: "#106B46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9724 17.2299C13.9937 17.04 13.1091 17.4538 12.5728 18.1645C12.0364 17.4538 11.1518 17.0351 10.1731 17.2299C9.218 17.4148 8.43695 18.1986 8.23933 19.1819C7.90998 20.8273 9.11449 22.273 10.6437 22.273C11.4294 22.273 12.1211 21.8836 12.5728 21.2897C13.0244 21.8836 13.7161 22.273 14.5019 22.273C16.031 22.273 17.2355 20.8273 16.9062 19.1819C16.7086 18.1986 15.9275 17.4148 14.9724 17.2299Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtmanagement);
export default __webpack_public_path__ + "static/media/debtmanagement.f3b9d5f98310d7471ac522955e66af73.svg";
export { ForwardRef as ReactComponent };